import BuildingPage from "./BuildingPage";

export default BuildingPage;
